/**
 * Transliteration utility for Cyrillic characters to Latin equivalents.
 * Useful for matching Russian artist names in international search engines like Spotify/Deezer/iTunes.
 */
export const transliterate = (text) => {
    if (!text) return '';

    const cyr = [
        'а', 'б', 'в', 'г', 'д', 'е', 'ё', 'ж', 'з', 'и', 'й', 'к', 'л', 'м', 'н', 'о', 'п',
        'р', 'с', 'т', 'у', 'ф', 'х', 'ц', 'ч', 'ш', 'щ', 'ъ', 'ы', 'ь', 'э', 'ю', 'я',
        'А', 'Б', 'В', 'Г', 'Д', 'Е', 'Ё', 'Ж', 'З', 'И', 'Й', 'К', 'Л', 'М', 'Н', 'О', 'П',
        'Р', 'С', 'Т', 'У', 'Ф', 'Х', 'Ц', 'Ч', 'Ш', 'Щ', 'Ъ', 'Ы', 'Ь', 'Э', 'Ю', 'Я',
        // Ukrainian specific letters
        'і', 'ї', 'є', 'ґ', 'І', 'Ї', 'Є', 'Ґ'
    ];
    const lat = [
        'a', 'b', 'v', 'g', 'd', 'e', 'yo', 'zh', 'z', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p',
        'r', 's', 't', 'u', 'f', 'h', 'ts', 'ch', 'sh', 'sch', '', 'y', '', 'e', 'yu', 'ya',
        'A', 'B', 'V', 'G', 'D', 'E', 'Yo', 'Zh', 'Z', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P',
        'R', 'S', 'T', 'U', 'F', 'H', 'Ts', 'Ch', 'Sh', 'Sch', '', 'Y', '', 'E', 'Yu', 'Ya',
        // Ukrainian specific letters -> Latin
        'i', 'yi', 'ye', 'g', 'I', 'Yi', 'Ye', 'G'
    ];

    let result = '';
    for (let i = 0; i < text.length; i++) {
        const char = text[i];
        const index = cyr.indexOf(char);
        if (index !== -1) {
            result += lat[index];
        } else {
            result += char;
        }
    }
    return result;
};

/**
 * Fuzzy normalization for track matching.
 * - Lowercase
 * - Remove non-alphanumeric
 * - Replace 'th' with 't'
 * - Replace 'ph' with 'f'
 * - Replace 'ae' with 'e'
 * - Replace 'z' with 's' (common in phonetic variations)
 */
export const fuzzyNormalize = (str) => {
    if (!str) return '';
    const search = ['th', 'ph', 'ae', 'z', 'j'];
    const replace = ['t', 'f', 'e', 's', 'i'];
    let res = str.toLowerCase().replace(/&/g, 'and').replace(/[^a-z0-9а-я]/g, '');
    for (let i = 0; i < search.length; i++) {
        res = res.split(search[i]).join(replace[i]);
    }
    return res;
};

export default transliterate;
